import Vue from 'vue'
import Router from 'vue-router'

import Cadastrese from '@/components/pages/Cadastrese'
import CadastroWizard from '@/components/pages/cadastrese/CadastroWizard'
import Pergunta from '@/components/pages/cadastrese/Pergunta'
import Sinsaude from '@/components/pages/cadastrese/Sinsaude'
import SaibaMaisPlano from '@/components/pages/SaibaMaisPlano'
import SaibaMaisPlano2 from '@/components/pages/SaibaMaisPlano2'
import SaibaMaisPlano3 from '@/components/pages/SaibaMaisPlano3'
import FormUsuario from '@/components/pages/cadastrese/Usuario'
import FormUsuarioDrAchei from '@/components/pages/cadastrese/UsuarioDrachei'
import Ativacao from '@/components/pages/cadastrese/Ativacao'
import Sucesso from '@/components/pages/cadastrese/Sucesso'

import Login from '@/components/pages/Login'
import LoginCliente from '@/components/pages/LoginCliente'

/* Busca */
import Busca from '@/components/busca/Busca'

import Precadastro from '@/components/precadastro/Precadastro'
import PrecadastroForm from '@/components/precadastro/Form'
import PrecadastroValidacao from '@/components/precadastro/Validacao'
import PrecadastroSucesso from '@/components/precadastro/Sucesso'

/* Dashboard */
import Dashboard from '@/components/pages/dashboard/Dashboard'
import HomeAdmin from '@/components/pages/dashboard/HomeAdmin'
import DadosCredenciado from '@/components/pages/dashboard/DadosCredenciado'

/* Dashboard Cliente */
import DashboardCliente from '@/components/pages/dashboard-cliente/DashboardCliente'
import HomeAdmCliente from '@/components/pages/dashboard-cliente/HomeAdmCliente'
import MeusDadosCliente from '@/components/pages/dashboard-cliente/MeusDadosCliente'
import AvaliacoesCliente from '@/components/pages/dashboard-cliente/AvaliacoesCliente'

/* Single Page */
import Single from '@/components/pages/single-consultorio/Single'
import ServicosList from '@/components/pages/single-consultorio/ServicosTab'
import XpTab from '@/components/pages/single-consultorio/XpTab'
import ReviewsTab from '@/components/pages/single-consultorio/ReviewsTab'

import PageCadastroProfissional from '@/components/pages/dashboard/CadastroProfissional'
import CadastroProfissionalForm from '@/components/cadastroProfissional/Form'
import CadastroProfissionalList from '@/components/cadastroProfissional/List'
import AgendaProfissionalForm from '@/components/cadastroProfissional/AgendaProfissionalForm'

import DadosProfissionalAutenticado from '@/components/pages/dashboard/DadosProfissionalAutenticado'
import PageProntuario from '@/components/pages/dashboard/Prontuarios'

import Agendamento from '@/components/pages/dashboard/agendamento/Agendamento'
import Calendario from '@/components/pages/dashboard/agendamento/Calendario'

import FormSinSaude from '@/components/pages/FormSinSaude'

/* Pagamentos */
import Checkout from '@/components/pages/pagamentos/Checkout'
import CheckoutSinSaude from '@/components/pages/pagamentos/CheckoutSinSaude'
import Voucher from '@/components/pages/pagamentos/Voucher'

/* Orçamento */
import Orcamento from '@/components/pages/orcamento/OrcamentoPage'

import ValidacaoCartaoSinsaude from '@/components/pages/dashboard/ValidacaoCartaoSinsaude'
import ValidacaoVoucherDrAchei from '@/components/pages/dashboard/ValidacaoVoucher'

import AvaliacaoForm from '@/components/pages/dashboard-cliente/AvaliacaoForm'

/* TipoRegistro */
import TipoRegistro from '@/components/pages/tipoRegistro/TipoRegistro'

/* Usuario atendente */
import UsuarioAtendente from '@/components/pages/usuarioAtendente/UsuarioAtendente'

/* Depoimentos do site DrAchei */
import DrAcheiDepoimento from '@/components/pages/drAcheiDepoimentos/DrAcheiDepoimento'

import Planos from '@/components/pages/planos/Planos'

import VoucherCartao from '@/components/pages/pagamentos/VoucherCartao'

import FinanceiroForm from '@/components/pages/dashboard/financeiro/FinanceiroForm'

const Home = () => import('@/components/pages/Home')
const HomeProfissionais = () => import('@/components/pages/PageProfissionais')
const SinSaudeCard = () => import('@/components/pages/SinSaudeCard')
const QuemSomos = () => import('@/components/pages/QuemSomos')
const SobreNos = () => import('@/components/pages/SobreNos')
const DrAcheiEmpresas = () => import('@/components/pages/DrAcheiEmpresas')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      meta: {
        bodyClass: 'checkout-page'
      }
    },
    {
      path: '/checkout-sinsaude',
      name: 'CheckoutSinSaude',
      component: CheckoutSinSaude,
      meta: {
        bodyClass: 'checkout-page'
      }
    },
    {
      path: '/logincliente',
      name: 'LoginCliente',
      component: LoginCliente,
      meta: {
        bodyClass: 'login-cliente'
      }
    },
    {
      path: '/busca',
      name: 'Busca',
      component: Busca,
      meta: {
        bodyClass: 'resultado-busca'
      }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { bodyClass: 'homepage' }
    },
    {
      path: '/profissionais',
      name: 'HomeProfissionais',
      component: HomeProfissionais,
      meta: {
        bodyClass: 'page-profissionais'
      }
    },
    {
      path: '/sinsaudecard',
      name: 'SinSaudeCard',
      component: SinSaudeCard,
      meta: {
        bodyClass: 'page-sinsaude'
      }
    },
    {
      path: '/saibamais',
      name: 'SaibaMaisPlano',
      component: SaibaMaisPlano,
      meta: {
        bodyClass: 'page-saibamais'
      }
    },
    {
      path: '/saibamais-2',
      name: 'SaibaMaisPlano2',
      component: SaibaMaisPlano2,
      meta: {
        bodyClass: 'page-saibamais'
      }
    },
    {
      path: '/saibamais-3',
      name: 'SaibaMaisPlano3',
      component: SaibaMaisPlano3,
      meta: {
        bodyClass: 'page-saibamais'
      }
    },
    {
      path: '/quemsomos',
      name: 'QuemSomos',
      component: QuemSomos,
      meta: {
        bodyClass: 'page-quemsomos'
      }
    },
    {
      path: '/cadastre-se',
      name: 'Cadastrese',
      component: Cadastrese,
      meta: {
        bodyClass: 'cadastro-usuario'
      },
      children: [
        {
          path: 'check',
          name: 'Cadastrese-pergunta',
          component: Pergunta,
          meta: {
            bodyClass: 'page-about'
          }
        },
        {
          path: 'sinsaude',
          name: 'Cadastrese-sinsaude',
          component: Sinsaude,
          meta: {
            bodyClass: 'page-about'
          }
        },
        {
          path: 'form/usuario',
          name: 'Cadastrese-usuario',
          component: FormUsuario,
          meta: {
            bodyClass: 'page-about'
          }
        },
        {
          path: 'form/usuarioDrAchei',
          name: 'Cadastrese-usuarioDrAchei',
          component: FormUsuarioDrAchei,
          meta: {
            bodyClass: 'page-about'
          }
        },
        {
          path: 'usuario/ativacao',
          name: 'Cadastrese-ativacao',
          component: Ativacao,
          meta: {
            bodyClass: 'page-about'
          }
        },
        {
          path: 'usuario/ativacao/sucesso',
          name: 'Cadastrese-sucesso',
          component: Sucesso,
          meta: {
            bodyClass: 'page-about'
          }
        }
      ]
    },
    {
      path: '/aboutus',
      name: 'SobreNos',
      component: SobreNos,
      meta: {
        bodyClass: 'page-about'
      }
    },
    {
      path: '/dracheiempresas',
      name: 'DrAcheiEmpresas',
      component: DrAcheiEmpresas,
      meta: {
        bodyClass: 'page-about'
      }
    },
    {
      path: '/voucher',
      name: 'Voucher',
      component: Voucher,
      meta: {
        bodyClass: 'vouchers'
      }
    },
    {
      path: '/voucherCartao',
      name: 'voucherCartao',
      component: VoucherCartao,
      meta: {
        bodyClass: 'vouchers'
      }
    },
    {
      path: '/test-checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/admincliente',
      name: 'Meu Dr.Achei',
      component: DashboardCliente,
      children: [
        {
          path: '',
          name: 'HomeAdmCliente',
          component: HomeAdmCliente,
          meta: {
            bodyClass: 'menu-position-side menu-side-left dashboard-cliente'
          }
        },
        {
          path: '/dados',
          name: 'MeusDadosCliente',
          component: MeusDadosCliente,
          meta: {
            bodyClass: 'dashboard-cliente'
          }
        },
        {
          path: '/avaliacoes-cliente',
          name: 'AvaliacoesCliente',
          component: AvaliacoesCliente,
          meta: {
            bodyClass: 'dashboard-cliente'
          }
        }
      ]
    },
    {
      path: '/avaliar-atendimento',
      name: 'AvaliarAtendimentoForm',
      component: AvaliacaoForm,
      meta: {
        bodyClass: 'dashboard-cliente'
      }
    },
    {
      path: '/admin',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        bodyClass: 'menu-position-side menu-side-left dashboard',
        requireAuth: true
      },
      children: [
        {
          path: '',
          name: 'HomeAdmin',
          component: HomeAdmin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'profissional/form',
          name: 'PageProfissionalAutenticado',
          component: DadosProfissionalAutenticado,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'agendamentos',
          name: 'PageAgendamento',
          component: Agendamento,
          meta: {
            requireAuth: true
          }
        },
        {
          component: Calendario,
          name: 'PageAgendamentoCalendario',
          path: 'agendamentos/calendar',
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'prontuarios',
          name: 'PageProntuario',
          component: PageProntuario,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/cadastroProfissional',
          component: PageCadastroProfissional,
          name: 'PageCadastroProfissional',
          meta: {requireAuth: true},
          children: [
            {
              name: 'PageCadastroProfissionalList',
              path: 'list',
              component: CadastroProfissionalList,
              meta: {requireAuth: true}
            },
            {
              name: 'PageCadastroProfissionalForm',
              path: 'form',
              component: CadastroProfissionalForm,
              meta: {requireAuth: true}
            },
            {
              name: 'AgendaProfissionalForm',
              path: 'agenda',
              component: AgendaProfissionalForm,
              meta: {requireAuth: true}
            }
          ]
        },
        {
          name: 'PageDadosCredenciado',
          component: DadosCredenciado,
          path: 'credenciado',
          meta: {requireAuth: true}
        },
        {
          component: ValidacaoCartaoSinsaude,
          name: 'PageValidacaoCartaoSinsaude',
          path: 'cartaoSinsaude',
          meta: {requireAuth: true}
        },
        {
          component: ValidacaoVoucherDrAchei,
          name: 'PageValidacaoVoucherDrAchei',
          path: 'voucher',
          meta: {requireAuth: true}
        },
        {
          component: TipoRegistro,
          name: 'TipoRegistroForm',
          path: 'tipoRegistro',
          meta: {requireAuth: true}
        },
        {
          component: UsuarioAtendente,
          name: 'usuarioAtendente',
          path: 'usrAtendente',
          meta: {requireAuth: true}
        },
        {
          component: DrAcheiDepoimento,
          name: 'drAcheiDepoimento',
          path: 'drAcheiDepoimento',
          meta: {requireAuth: true}
        },
        {
          component: Planos,
          name: 'planos',
          path: 'planos',
          meta: {requireAuth: true}
        },
        {
          component: FinanceiroForm,
          name: 'FinanceiroForm',
          path: 'financeiro',
          meta: {requireAuth: true}
        }
      ]
    },
    {
      path: '/:servico/:descricao/menorPreco/:preco/:nomeRede/:cidade',
      name: 'Single',
      component: Single,
      meta: {
        bodyClass: 'single-page'
      },
      children: [
        {
          path: '',
          name: 'ServicosList',
          component: ServicosList
        },
        {
          path: '/single/experiencia',
          name: 'XpTab',
          component: XpTab
        },
        {
          path: '/single/avaliacoes',
          name: 'ReviewsTab',
          component: ReviewsTab
        }
      ]
    },
    {
      path: '/precadastro',
      name: 'PrecadastroMain',
      component: Precadastro,
      meta: {
        bodyClass: 'single-page'
      },
      children: [
        {
          path: 'form',
          name: 'Precadastro',
          component: PrecadastroForm,
          meta: {
            bodyClass: 'pre-cadastro'
          }
        },
        {
          path: 'validacao',
          name: 'Precadastro-validacao',
          component: PrecadastroValidacao,
          meta: {
            bodyClass: 'pre-cadastro'
          }
        },
        {
          path: 'sucesso',
          name: 'Precadastro-sucesso',
          component: PrecadastroSucesso,
          meta: {
            bodyClass: 'pre-cadastro'
          }
        }
      ]
    },
    {
      path: '/cadastro-wizard',
      name: 'CadastroWizard',
      component: CadastroWizard,
      meta: {
        bodyClass: 'cadastro-wizard'
      }
    },
    {
      path: '/orcamento',
      name: 'Orcamento',
      component: Orcamento,
      meta: {
        bodyClass: 'orcamento'
      }
    },
    {
      path: '/form-sinsaude',
      name: 'FormSinSaude',
      component: FormSinSaude,
      meta: {
        bodyClass: 'formsinsaude'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js